import React from 'react';
import { Redirect, RedirectProps } from 'react-router-dom';

export type EnabledRedirect = RedirectProps & {
  enabled: boolean;
};

type RedirectWhenEnabledProps = {
  redirects: EnabledRedirect[];
};

const RedirectWhenEnabled: React.FC<RedirectWhenEnabledProps> = (props) => {
  const redirect = props.redirects.find((enabledPath) => Boolean(enabledPath.enabled));

  if (redirect) {
    const { enabled, push = true, ...redirectProps } = redirect;
    return <Redirect push={push} {...redirectProps} />;
  }

  return <>{props.children}</>;
};

export default RedirectWhenEnabled;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/auth/components/RedirectWhenEnabled.tsx